import { MoneyScaled } from '@quickbit/qb-design-system';
import { fetchAPI } from 'api';
import { InitiateExternalRefundResponse } from 'pages/api';

export const initiateExternalRefund = (
  orderId: string,
  refundDestinationAddress: string,
  amount: MoneyScaled
) => {
  return fetchAPI<InitiateExternalRefundResponse>(
    `v1/order/${orderId}/initiate-external-refund`,
    {
      method: 'POST',
      body: {
        refundDestinationAddress,
        amount,
      },
    }
  );
};
